import { makeTile, type Tile } from '../types.js';
import { ALL_FIVES } from './allFives.js';
import type { DominoRuleSet } from './types.js';

/** Телефон opening order: [2|3], then the doubles [1|1] … [6|6]. */
export const TELEFON_FIRST_HAND_PRIORITY: readonly Tile[] = [
  makeTile(2, 3),
  makeTile(1, 1),
  makeTile(2, 2),
  makeTile(3, 3),
  makeTile(4, 4),
  makeTile(5, 5),
  makeTile(6, 6),
];

/**
 * Телефон (Telephone) — the Russian All Fives game. Same set size, same
 * Muggins scoring on 5-multiples mid-game, same end-of-hand bonus. Three
 * differences:
 *
 * 1. **Forced first-hand lead** — the first hand of a match starts with a
 *    fixed-tile opening: the seat holding [2|3] leads; if [2|3] is in the
 *    boneyard, fall back to [1|1] → [2|2] → ... → [6|6], then to the
 *    lowest pip-sum tile in any hand. The leader MUST play that tile on
 *    turn 1.
 * 2. **Lead only scores on [5|5]** — every hand's first play scores 0
 *    unless the lead is the double-five (open ends 5+5 = 10).
 * 3. **Lead rotates clockwise between hands** — the next hand is led by
 *    the seat to the left of the previous hand's leader, regardless of
 *    who won; the lead never sits with one seat for two consecutive hands.
 *
 * Shipped under the id `kozyol` before the rename; that id stays a
 * permanent read-side alias (see `normalizeVariantId`).
 */
export const TELEFON: DominoRuleSet = {
  ...ALL_FIVES,
  id: 'telefon',
  // Телефон deals 7 tiles per seat regardless of player count.
  // 4 players × 7 = 28 leaves an empty boneyard (block-style).
  handSize: { 2: 7, 3: 7, 4: 7 },
  scoring: 'fives',
  firstHandLeadPriority: TELEFON_FIRST_HAND_PRIORITY,
  leadScoresOnlyOnDoubleFive: true,
  nextHandLeader: 'rotate',
};

export const TELEFON_PARTNERSHIP: DominoRuleSet = {
  ...TELEFON,
  id: 'telefon-2v2',
  partnership: true,
};
